import React, { useEffect } from "react";
import { useState, useRef } from "react";
import { Container, Row, Col, Button } from "reactstrap";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Modal } from "react-bootstrap";
import { IoChevronForwardCircleSharp } from "react-icons/io5";
import { IoChevronBackCircleSharp } from "react-icons/io5";
import { IoSearchOutline } from "react-icons/io5";

import { getGlossary, UpdateStatusGlossary } from "../../../stores/services/knowledgebase.service";
import AddGlossary from "./AddGlossary";
import EditGlossary from "./EditGlossary";
import ViewGlossary from "./ViewGlossary";
import { useSelector } from "react-redux";

const Glossary = () => {
    const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
    const scrollLetters: any = useRef(null)
    const [showScrollIconsLeft, setShowScrollIconsLeft] = useState(false);
    const [showScrollIconsRight, setShowScrollIconsRight] = useState(true);
    const [addModalFlag, setAddModalFlag] = useState<boolean>(false)
    const [editModalFlag, setEditModalFlag] = useState<boolean>(false)
    const [viewModalFlag, setViewModalFlag] = useState<boolean>(false)
    const [loading, setLoading] = useState<boolean>(false)
    const [refreshData, setRefreshData] = useState<boolean>(false)
    const [allGlossaryData, setAllGlossaryData] = useState<any>([])
    // const [tempData, setTempData] = useState<any>([])
    const [title, setTitle] = useState<string>("")
    const [letter, setLetter] = useState<string>("All")
    const [status, setStatus] = useState<string>("false")
    const email = sessionStorage.getItem("email") || "";
    const amc_code = sessionStorage.getItem("amc_code") || "";
    const itemsPerPage = 10
    const [itemsToShow, setItemsToShow] = useState(10);

    const capitalLetters = ["All", "A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U", "V", "W", "X", "Y", "Z"];

    useEffect(() => {
        const getAllData = async () => {
            setLoading(true)
            try {
                let res = await getGlossary(
                    email,
                    amc_code,
                    title ? title?.trim() : "",
                    (letter && letter !== "All") ? letter : "",
                )
                if (res.status === 200 && res.data.status === 200) {
                    if (res.data.data?.length > 0) {
                        setAllGlossaryData(res?.data?.data)
                        // if (title == "" && letter == "") {
                        //     setTempData(res?.data?.data)
                        // }
                    }
                    else {
                        toast.error("No Record Found!")
                        setAllGlossaryData([])
                    }
                }
                else {
                    toast.error("No Record Found!")
                    setAllGlossaryData([])
                }
            }
            catch (error) {
                toast.error("No Record Found!")
                setAllGlossaryData([])
            }
            finally {
                setLoading(false)
            }
        }
        getAllData()
    }, [refreshData])

    const handleShowMore = () => {
        setItemsToShow(prev => prev + itemsPerPage);
    };

    const changeStatus = async (item) => {
        setLoading(true)
        let status;
        if (item?.status == true) {
            status = "false"
        }
        else {
            status = "true"
        }
        try {
            let res = await UpdateStatusGlossary(
                email,
                amc_code,
                item?._id || "",
                status
            )
            if (res.status === 200 && res.data.status === 200) {
                toast.success(res.data.message)
                setRefreshData(!refreshData)
            }
        }
        catch (error) {
            toast.error("Error Updating Status")
        }
        finally {
            setLoading(false)
        }
    }

    const renderTable = () => {
        return allGlossaryData?.slice(0, itemsToShow)?.map((item: any, index: any) => {
            return (
                <tr key={index}>
                    <td data-toggle="tooltip" data-placement="top" title={item?.title}>
                        {item.title?.slice(
                            0,
                            150
                        )}{" "}
                        {item.title.length >
                            150 && "..."}
                    </td>
                    <td data-toggle="tooltip" data-placement="top" title={item?.description}>
                        {item.description?.slice(
                            0,
                            550
                        )}{" "}
                        {item.description.length >
                            550 && "..."}
                    </td>
                    <td>
                        {item?.letter}
                    </td>
                    <td className=" ">
                        <div className="multi-icons pointer">
                            <button
                                type="button"
                                className="btn-icon btn-link like btn btn-primary btn-sm"
                                onClick={() => {
                                    sessionStorage.setItem("GlossaryObj", JSON.stringify(item));
                                    setViewModalFlag(true)
                                }}
                            >
                                <i className="fas fa-eye"></i>
                            </button>

                            <button
                                type="button"
                                className="btn-icon btn-link like btn btn-info btn-sm"
                                onClick={() => {
                                    sessionStorage.setItem("GlossaryObj", JSON.stringify(item));
                                    setEditModalFlag(true)
                                }}
                            >
                                <i className="tim-icons icon-pencil"></i>
                            </button>
                            {item?.status != true ? (
                                <button
                                    type="button"
                                    className="btn-icon btn-link like btn btn-danger btn-sm"
                                    onClick={() => {
                                        changeStatus(item)
                                    }}
                                >
                                    <i className="tim-icons icon-simple-remove"></i>
                                </button>
                            ) : (
                                <button
                                    type="button"
                                    className="btn-icon btn-link like btn btn-success btn-sm"
                                    onClick={() => {
                                        changeStatus(item)
                                    }}
                                >
                                    <i className="fas fa-check"></i>
                                </button>
                            )}
                        </div>
                    </td>
                </tr>
            );
        });
    }

    return (
        <div className="content">
            <ToastContainer />
            {/* ---------------- Add Modal ------------ */}
            <Modal
                className=""
                dialogClassName="modal90w"
                show={addModalFlag ? true : false}
                size="lg"
                backdrop={true}
                onHide={() => {
                    setAddModalFlag(false);
                }}
                centered={true}
            >
                <div className="modal-header ">
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => {
                            setAddModalFlag(false);
                        }}
                    >
                        <i className="tim-icons icon-simple-remove" />
                    </button>
                    <h6 className="title title-up">Add Glossary</h6>
                </div>
                <div className="modal-body">
                    <AddGlossary
                        refreshData={refreshData}
                        setRefreshData={setRefreshData}
                        setAddModalFlag={setAddModalFlag}
                    />
                </div>
            </Modal>

            {/* ---------------- Edit Modal ------------ */}
            <Modal
                className=""
                dialogClassName="modal90w"
                show={editModalFlag ? true : false}
                size="lg"
                backdrop={true}
                onHide={() => {
                    setEditModalFlag(false);
                }}
                centered={true}
            >
                <div className="modal-header ">
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => {
                            setEditModalFlag(false);
                        }}
                    >
                        <i className="tim-icons icon-simple-remove" />
                    </button>
                    <h6 className="title title-up">Edit Glossary</h6>
                </div>
                <div className="modal-body">
                    <EditGlossary
                        refreshData={refreshData}
                        setRefreshData={setRefreshData}
                        setEditModalFlag={setEditModalFlag}
                    />
                </div>
            </Modal>

            {/* ---------------- View Modal ------------ */}
            <Modal
                className=""
                dialogClassName="modal90w"
                show={viewModalFlag ? true : false}
                size="lg"
                backdrop={true}
                onHide={() => {
                    setViewModalFlag(false);
                }}
                centered={true}
            >
                <div className="modal-header ">
                    <button
                        aria-hidden={true}
                        className="close"
                        data-dismiss="modal"
                        type="button"
                        onClick={() => {
                            setViewModalFlag(false);
                        }}
                    >
                        <i className="tim-icons icon-simple-remove" />
                    </button>
                    <h6 className="title title-up">View Glossary</h6>
                </div>
                <div className="modal-body">
                    <ViewGlossary
                        setViewModalFlag={setViewModalFlag}
                    />
                </div>
            </Modal>

            <Row>
                <Col md="12">
                    <Container fluid>
                        <ToastContainer limit={1} />
                        <div className="card">
                            <div className="card-header">
                                <h4 className="card-title">
                                    Glossary Listing
                                    <button
                                        className="btn btn-primary btn-sm float-right"
                                        onClick={() => {
                                            setAddModalFlag(true)
                                        }}
                                    >
                                        <i className="fa fa-plus mr-2"></i> Add New
                                    </button>
                                </h4>
                            </div>

                            <div
                                // style={{
                                //     minHeight: "90vh"
                                // }}
                                className="card-body">
                                <Col md={12}>
                                    <Row className="align-items-center">
                                        <Col md={10}>
                                            <div className="d-flex justify-content-between align-items-center">

                                                {showScrollIconsLeft && (
                                                    <IoChevronBackCircleSharp
                                                        style={{
                                                            width: "40px",
                                                            height: "40px",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => {
                                                            if (scrollLetters.current) {
                                                                // scrollLetters.current.scrollLeft -= 20;
                                                                scrollLetters.current.scrollTo({
                                                                    left: scrollLetters.current.scrollLeft - 20,
                                                                    behavior: 'smooth'
                                                                });

                                                                // true/false ki base par icon hide or show krta left wala
                                                                setShowScrollIconsLeft(scrollLetters.current.scrollLeft > 0);

                                                                // true/false ki base par icon hide or show krta right wala
                                                                setShowScrollIconsRight(
                                                                    scrollLetters.current.scrollLeft + scrollLetters.current.clientWidth < scrollLetters.current.scrollWidth
                                                                );
                                                            }
                                                        }}
                                                        className="mr-2"
                                                    />
                                                )}

                                                <div
                                                    ref={scrollLetters}
                                                    id="Glossary_Scrollable"
                                                    style={{
                                                        overflowX: "auto",
                                                    }}
                                                    className="d-flex justify-content-between"
                                                >
                                                    {capitalLetters?.map((ele) => (
                                                        <div
                                                            key={ele}
                                                            className={letter === ele ? `mx-3 ${theme == "dark" ? "bg-secondary" : "bg-dark text-white"} text-center` : "mx-3"}
                                                            style={{
                                                                cursor: "pointer",
                                                                minWidth: "22px",
                                                            }}
                                                            onClick={() => {
                                                                if (ele == "All") {
                                                                    setLetter("All")
                                                                    setRefreshData(!refreshData);
                                                                    setItemsToShow(10)
                                                                }
                                                                else {
                                                                    setLetter(ele);
                                                                    setRefreshData(!refreshData);
                                                                    setItemsToShow(10)
                                                                }
                                                            }}
                                                        >
                                                            {ele}
                                                        </div>
                                                    ))}
                                                </div>

                                                {showScrollIconsRight && (
                                                    <IoChevronForwardCircleSharp
                                                        style={{
                                                            width: "40px",
                                                            height: "40px",
                                                            cursor: "pointer",
                                                        }}
                                                        onClick={() => {
                                                            if (scrollLetters.current) {
                                                                // scrollLetters.current.scrollLeft += 20;
                                                                scrollLetters.current.scrollTo({
                                                                    left: scrollLetters.current.scrollLeft + 20,
                                                                    behavior: 'smooth'
                                                                });

                                                                // true/false ki base par icon hide or show krta left wala
                                                                setShowScrollIconsLeft(scrollLetters.current.scrollLeft > 0);

                                                                // true/false ki base par icon hide or show krta right wala
                                                                setShowScrollIconsRight(
                                                                    scrollLetters.current.scrollLeft + scrollLetters.current.clientWidth < scrollLetters.current.scrollWidth
                                                                );
                                                            }
                                                        }}
                                                        className="ml-2"
                                                    />
                                                )}
                                            </div>
                                        </Col>
                                        <Col md={2}>
                                            <input
                                                style={{
                                                    paddingRight: "38px"
                                                }}
                                                value={title}
                                                onKeyDown={(e) => {
                                                    if (e.key == "Enter") {
                                                        if (title !== "") {
                                                            setRefreshData(!refreshData)
                                                            setItemsToShow(10)
                                                        }
                                                    }
                                                }}
                                                onChange={(e) => {
                                                    if (e.target.value !== "") {
                                                        setTitle(e.target.value)
                                                        setItemsToShow(10)
                                                    }
                                                    else {
                                                        // setAllGlossaryData(tempData)
                                                        setTitle(e.target.value)
                                                        setItemsToShow(10)
                                                        setRefreshData(!refreshData)
                                                        // setLetter("All")
                                                    }
                                                }}
                                                className="form-control"
                                                placeholder='Search Term'
                                            />
                                            <IoSearchOutline
                                                onClick={() => {
                                                    if (title !== "") {
                                                        setRefreshData(!refreshData)
                                                        setItemsToShow(10)
                                                    }
                                                }}
                                                style={{
                                                    width: "25px",
                                                    height: "25px",
                                                    position: "absolute",
                                                    top: "11px",
                                                    right: "25px",
                                                    cursor: "pointer"
                                                }}
                                            />
                                        </Col>
                                    </Row>
                                </Col>
                                {!loading ? (
                                    allGlossaryData?.length > 0 ?
                                        <div className="table-responsive">
                                            <table className="table mt-3 ">
                                                <thead>
                                                    <th
                                                        style={{
                                                            paddingLeft: "7px",
                                                            paddingRight: "7px",
                                                        }}
                                                    >
                                                        Title
                                                    </th>
                                                    <th
                                                        style={{
                                                            paddingLeft: "7px",
                                                            paddingRight: "7px",
                                                        }}
                                                    >
                                                        Description
                                                    </th>
                                                    <th
                                                        style={{
                                                            paddingLeft: "7px",
                                                            paddingRight: "7px",
                                                        }}
                                                    >
                                                        Letter
                                                    </th>
                                                    <th
                                                        style={{
                                                            paddingLeft: "11px",
                                                            paddingRight: "11px",
                                                        }}
                                                    >
                                                        Actions
                                                    </th>

                                                </thead>
                                                <tbody>{renderTable()}</tbody>
                                            </table>

                                        </div>
                                        :
                                        <div className="text-center my-5">
                                            <b>No Record Found</b>
                                        </div>
                                ) : (
                                    <div className="d-flex justify-content-center">
                                        <div
                                            className="fa fa-spinner fa-spin fa-3x mt-5 mb-5"
                                            role="status"
                                        >
                                            <span className="sr-only">Loading...</span>
                                        </div>
                                    </div>
                                )}
                            </div>

                            {itemsToShow < allGlossaryData?.length && (
                                <div
                                    className='d-flex justify-content-center my-2'
                                >
                                    <button
                                        className="btn btn-primary mt-3"
                                        onClick={handleShowMore}
                                    >
                                        Show More
                                    </button>
                                </div>
                            )}
                        </div>
                    </Container>
                </Col>
            </Row >
        </div >
    );
};

export default Glossary;
